module.exports = __webpack_public_path__ + "media/Video 124.8537abd8.mp4";